const Lang =
{
        // Header
            Moon:"Moon",
            MoonEgypt:"Moon Egypt",
            Home: "Home",
            About: "About",
            Services: "Services",
            Projects: "Projects",
            ContactUs: "Contact Us",
            Lang: "English",
        //  footer
            Email:"Email : info@moonegypt.com",
            subscripUs:"know what new about us",
            YourEmail:"Your Email",
            subscrip:"subscrip",
            copyrights:"Copyright All Right Reserved To Moon Egypt",
        // Home
            Design: "design",
            SomeThing: "something",
            Gread: "Gread!",
            Unique: "Unique!",
            And: "and",
            To: "to",
            Reach: "reach",
            SeeMore: "See More",
            osSoftwares: "open-sources we use",
            moonWord:"Moon",
            stages:"stages",
            idea:"idea",
            ideaDesc:"we foucs on your idea and give many options to you",
            tools:"tools",
            uxdesign:"ux design",
            uidesign:"ui design",
            surveys:"surveys",
            coding:"Coding",
            codingDesc:"after idea completion, we starting to make your project with clean code and less issues",
            html:"HTML",
            css:"CSS",
            javascript:"Javascript",
            php:"PHP",
            laravel:"Laravel",
            sql:"SQL",
            nodejs:"Nods.js",
            expressjs:"Express.js",
            testing:"Testing",
            testingDesc:"After coding is done we willstart To test your website from All sides",
            ideaDesc:"we foucs on your idea and give many options to you",
            ideaDesc:"we foucs on your idea and give many options to you",
            ideaDesc:"we foucs on your idea and give many options to you",
            unittesting:"unit testing",
            integrationtesting:"integration testing",
            systemtesting:"system testing",
            acceptancetesting:"acceptance testing",
            sitesweets:"Site Sweets",
            sitesweetsDesc:"At this point we focus on  optimization performance, search engine and integration with tools that It can give you many charts about your site",
            marketplace:"marketplace",
            searchconsole:"search console",
            analytics:"analytics",
            ad:"Ad",
            lighthouse:"lighthouse",
            searchengines:"search engines",
            metatags:"meta tags",
            cloudflare:"cloudflare",
            deployment:"Deployment",
            deploymentDesc:"we help you to deployment your site on web to start your work easy and flexable",
            domain:"domain",
            hosting:"hosting",
            ssl:"ssl",
            gitandgithub:"git and github",
            emailaccounts:"email accounts",
            ownSmtp:"own Smtp",
        //  contactus
            TypeOfService:"Type Of Service",
            YourName:"Your Name",
            YourMessage:"Your Message",
            submit:"send",
            or:"or",
        // saas product
            saasProduct:"SaaS Product",
            saasProductDesc:"we help you to build your SaaS product to get money without any efforts",
            SaaSProductStatistics:"SaaS product Statistics",
            SaaSProductStatisticsdDesc:"number of SaaS produts in 2022 is 25k",
            SaaSProductInCountries:"SaaS product in countries",
            USA:"USA",
            UK:"UK",
            Canada:"Canada",
            Germany:"Germany",
            France:"France",
            others:"others",
            k17:"17k",
            k2:"2k",
            k1:"1k",
            one:"1",
            two:"2",
            three:"3",
            four:"4",
            five:"5",
            six:"6",
            howCanHelpYou:"How can help you?",
            createYourIdea:"create your idea",
            makeYourProduct:"make your product",
            integrationProduct:"integration your product with analytics tools",
            deploymentYourProduct:"deployment your product in moon",
            welcomeInMoon:"welcome in Moon",
            ourProduct:"our product",
            MoonForms:"Moon Forms",
        // wordpress
            Wordpress:"Wordpress",
            WordpressDesc:"we help you to build your website with easy  panel to control with website and  not need developer any more to edit your content",
            WordpressStatistics:"Wordpress Statistics",
            WordpressStatisticsdDesc1:"1. WordPress is used by 43.2% of all websites on the internet. (W3Techs, 2022)",
            WordpressStatisticsdDesc2:"2. WordPress usage has increased an average of 12% per year since 2011. (W3Techs, 2022)",        
            WordpressAndOtherCMS:"Wordpress and other CMS",
            Wordpress:"Wordpress",
            Shopify:"Shopify",
            Wix:"Wix",
            Squarespace:"Squarespace",
            Joomla:"Joomla",
            WordpressNum:"65.2%",
            ShopifyNum:"6.6%",
            WixNum:"2.8%",
            squarespaceNum:"2.7%",
            JoomlaNum:"2.6%",
            makeYourWordpress:"make your website with best themes and plugins ",
            ourProduct:"our product",
            MoonWordpress:"Moon Wordpress",
            //******************************* about ********************************************************///
            smallCompany : 'Moon Egypt is a small company we make it to help beginners in the Internet to spread their activity around the world without any restrictions',
            CreativeWebsite: 'create many website out of the box for our customers',
            communitiesWithPeople: 'We need many customers and create our communities with people from all the world' ,
            headquarters: 'Our company does not currently have a fixed headquarters, but rather it has a well-known domain and hosting on the Internet and our own e-mail, because we are a technical company whose goal is to establish internet services and we do not currently need to fixed headquarters',
            vision: "vision",
            note: "note",
            policies: "policies",
                    //////////////////// copyrightsPolicy    ////////////////////////////
            copyrightsPolicy: "Copyrights Policy",
            notToUseYourIdea : 'We commit not to use your idea or design in another project with the same shape and color.',
            codeDoesNotFallUnderCopyrightsRights : 'The code does not fall under Copyrights Policy rights, so it can be used with other projects, without prejudice to the previous point.',
            //////////////////////////      Accept Projects       //////////////////////
            AcceptProjects : 'Accept Projects Policy',
            SubjectToOurCapacity : 'We accept a limited number of projects at a time, subject to our capacity.',
            choosePreviousProject : 'We have the right to choose whether we can modify a previous project that was not created by us, and that depends on the structure of the code because sometimes it takes a long time to modify, and sometimes building another site is much better and less expensive.',
            ThePriority : 'The priority is to accept projects for our existing clients first and then new clients',
            // ////////////////////////   Pricing Policy  ////////////////////////////
            PricingPolicy : 'Pricing Policy',
            effortAndTechnologies : 'We determine the price of the project according to what we see fit in terms of the effort and technologies that will be used',
            limitedNumberOfProjects : 'We accept a limited number of projects at a time, subject to our capacity',
            projectIsLarge : 'When the project is large, the money is divided into batches, which are paid with the completion of each stage',
            discloseAnyPrices : "It is not permissible to disclose any prices that have been determined with you, and the company has the right to stop implementing the project and handing it over in its condition at the time of vacating this point" ,
            //////////////////  Project Policy //////////////////////
            ProjectPolicy : 'Project Policy',
            seriesOfMeetings : 'Spend a lot of time with you through a series of meetings to shape your idea well, and based on it the expected design of the project will be completed.',
            projectIsDivided : 'The project is divided into phases, and in each phase there is a meeting to explain the latest developments and find out your opinion before starting the next phase.',
            ModernTechnologies : 'Modern technologies are used and we do not rely on old projects, but our projects are updated first',
            beforeStartingToWriteTheCode :'An agreement is made on the expected form of your project before starting to write the code, and dealing is done on the basis of this form. but if there is a modification to this model after it has been designed. The company has the right to request additional funds for making these modifications.',
            ///////////////////////  After Sale Policy ///////////////////////////////////
            AfterSalePolicy : 'After Sale Policy',
            trainingToManage : 'We provide you with the necessary training to manage your project without the need for.',
            encryptAnyData : 'We deliver your entire project without hiding anything or encrypt any data.',
            completingYourProject : 'The company is committed to implementing your project, but we are not responsible for any action you take on your site after completing your project and handing it over to you, as it belongs to you and you are responsible for it.', 
           //******************************* service ********************************************************///
           threeParts : 'Any website contain of three parts.',
           beautifulDesign : 'we focus on beautiful design and best user experience',
           saveData : 'we focus how can save data , send emails, make admin panel to edit your site',
           union : 'we focus on union of people, process, and technology to continually provide value to customers.',
           ////*******************************************  Project  **************************/
           seeOurProjects : 'see our projects and projects of our clients',
           More : 'More',
           ecommerce: 'e-commerce',
           ecommerceLink: 'https://moda.moonegypt.com/en',
           demo:'Demo',
           cms: 'CMS',
           website: 'website',

}


export default Lang;
